var __TEMP__ = require('./_baseSetData.js');var baseSetData = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_shortOut.js');var shortOut = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = setData;
